export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/sedan-icon.a095e1fe.svg","height":10,"width":24,"blurWidth":0,"blurHeight":0};